Vue.filter('phrase', function (phrase) {
    if (!phrase) return '';
    var filtered = window._phrases.find(function (t) {  return t.title == phrase });
    var value = phrase;
    if (filtered != null) {
        value = filtered
    }
    return value;
});
